import { setConfig } from '@plug-core/appConfig'
import { processWalletAction } from '@plug-core/handlers/walletActions/processWalletAction'

setConfig('callWallet', (action, wallet, payload) =>
  processWalletAction({ action, payload, wallet })
)
